import { Apis, Labels } from '../../app.constants';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../APIService';
import {
  dynamicLeadFormAtom,
  interveneFilterAtom,
  leadAllCountsAtom,
  leadB2b2cDetailObjAtom,
  leadDetailObjAtom,
  userInfoByNumberAtom,
} from '../../_states';
import { useRecoilState, useResetRecoilState, useSetRecoilState } from 'recoil';
import { dateFormate } from '../../../utils/helper';
import { use } from 'react';

const LeadFormActions = () => {
  const [leadDetails, setLeadDetail] = useRecoilState(leadDetailObjAtom);
  // const [userDetailByNumber, setUserDetailByNumber] = useRecoilState(userInfoByNumberAtom);
  const setleadCounts = useSetRecoilState(leadAllCountsAtom);
  // const [interveneFilter, setInterveneFilter] = useRecoilState(interveneFilterAtom);
  // const resetDynamicForm = useResetRecoilState(dynamicLeadFormAtom);
  const despositionStatusArr = [
    { label: 'Call later', value: 'Call later' },
    { label: 'Dead Lead', value: 'Dead Lead' },
    { label: 'Follow-up', value: 'Follow-up' },
    { label: 'Form Filled', value: 'Form Filled' },
    { label: 'Hang up', value: 'Hang up' },
    { label: 'Interested', value: 'Interested' },
    { label: 'Language Barrier', value: 'Language Barrier' },
    { label: 'Lead', value: 'Lead' },
    { label: 'No Voice', value: 'No Voice' },
    { label: 'Non-TG', value: 'Non-TG' },
    { label: 'Not Eligible', value: 'Not Eligible' },
    { label: 'Not Interested', value: 'Not Interested' },
    { label: 'POC Update', value: 'POC Update' },
    { label: 'RNR', value: 'RNR' },
    { label: 'Ringing but no response', value: 'Ringing but no response' },
    { label: 'Share over whatsapp', value: 'Share over whatsapp' },
    { label: 'Switch OFF', value: 'Switch OFF' },
    { label: 'Wrong Details', value: 'Wrong Details' },
    { label: 'Wrong Number', value: 'Wrong Number' },
  ];
  const getFormsByCampaignId = async (campaignId) => {
    let res = await APIService.get(`v0/ui/leads/${campaignId}/form`);
    return res;
  };

  const updateLeadStatusDate = async (data) => {
    let res = await APIService.post(`${Apis.updateLeadStatus}?id=${data?.id}`, { data: data });
    return res;
  };

  const updateLeadStatusDate1 = async (payload) => {
    let res;

    if (!payload?.id) {
      res = await APIService.post(`${Apis.updateLeadStatus}`, payload);
    } else {
      res = await APIService.post(`${Apis.updateLeadStatus}?id=${payload.id}`, payload);
    }

    return res;
  };

  const fetchLeadStatus = async (data) => {
    let res = await APIService.get(`${Apis.updateLeadStatus}?id=${data?.id}`);
    return res;
  };

  const fetchLeadStatus1 = async (data) => {
    let res = await APIService.get(`${Apis.updateLeadStatus1}?id=${data?.id}`);
    return res;
  };

  const addReferences = async (data, id) => {
    let res = await APIService.post(`${Apis.addReferences}?id=${id}`, { data: data });
    if (res?.status) SweetAlert('Add References successfully', 'success');
    else SweetAlert('Failed to Add', 'error');
  };

  const getCommentById = async (id) => {
    let res = await APIService.get(`${Apis.getPostComment}?id=${id}`);
    if (res?.status == 200) return res;
    else SweetAlert(Labels.Error, 'error');
  };

  const postCommentById = async (data, id) => {
    let res = await APIService.post(`${Apis.getPostComment}?id=${id}`, { data: data });
    return res;
  };

  const getLeadImagesById = async (id) => {
    let res = await APIService.get(`${Apis.getPostLeadImagesById}?id=${id}`);
    if (res?.status == 200) return res;
    else SweetAlert(Labels.Error, 'error');
  };

  const uploadLeadImageById = async (id, formdata) => {
    let res = await APIService.post(`${Apis.getPostLeadImagesById}?id=${id}`, formdata, {
      'Content-Type': 'multipart/form-data',
    });
    return res;
  };

  const getLeadAudioById = async (id) => {
    let res = await APIService.get(`${Apis.getPostLeadAudioById}?id=${id}`);
    if (res?.status == 200) return res;
    else SweetAlert(Labels.Error, 'error');
  };

  const uploadLeadAudioById = async (id, formdata) => {
    let res = await APIService.post(`${Apis.getPostLeadAudioById}?id=${id}`, formdata, {
      'Content-Type': 'multipart/form-data',
    });
    if (res?.data?.status) SweetAlert(`${res?.data?.data}`, 'success');
  };

  const getLeadsByFormId = async () => {
    let res = await APIService.get(`/v0/ui/leads/404/entry_list/?page_number=1`);
    if (res?.status == 200) {
      return res?.data || {};
    } else SweetAlert(Labels.Error, 'error');
  };

  const getDetailsByNumber = async (number) => {
    try {
      let res = await APIService.get(`${Apis.getDetailsByNumber}?phone_number=${number}`);
      return res;
    } catch (error) {
      SweetAlert(Labels.Error, 'error');
    }
    // if (res?.status === 200) {
    //   if (res?.data === 'Not found') {
    //     setUserDetailByNumber({});
    //     resetDynamicForm();
    //     SweetAlert('User not found', 'warning');
    //     return 0;
    //   }
    //   let data = { ...res?.data }
    //   data?.data?.forEach((element) => {
    //     if (element?.column_name === 'supplier_id') {
    //       data['supplier_id'] = element['value'] || ''
    //     }
    //     if (element?.column_name === 'city') {
    //       data['city'] = element['value'] || ''
    //     }
    //     if (element?.column_name === 'area') {
    //       data['area'] = element['value'] || ''
    //     }
    //   });
    //   data['leadform_Id'] = userDetailByNumber?.leadform_Id || '';
    //   data['campaign_id'] = userDetailByNumber?.campaign_id || '';
    //   setUserDetailByNumber(data);
    // } else {
    //   console.log("error")
    // }
  };

  const getLeadCounts = async (data) => {
    const res = await APIService.get(
      `${Apis.getLeadCountsByParams}?supplier_id=${data?.supplier_id}&campaign_id=${data?.campaign_id}&leads_form_id=${data?.leadform_Id}`
    );

    if (res?.status === 200) {
      setleadCounts(res?.data);
    }

    return res;
  };

  const updateQcStatus = async (data) => {
    let res = await APIService.post(`${Apis.updateQcStatus}?id=${data?.id}`, {});
    if (res?.data?.status) SweetAlert(`${res?.data?.data}`, 'success');
    else SweetAlert('Failed to Submit Leads', 'error');
  };

  // const getUserDetailsByParams = async (data) => {
  //   let url = `${Apis.getLeadsCampaignSupplier}?campaign_id=${data?.campaign_id}&supplier_id=${data?.supplier_id}&leads_form_id=${data?.leadform_Id}&phone_number=${data?.phone_number}`;
  //   if (data?.leadId) {
  //     url += `&lead_id=${data.leadId}`;
  //   }
  //   if (data?.search) {
  //     url += `&search=${data.search}`;
  //   }
  //   if (data?.page) {
  //     url += `&page=${data.page}`;
  //   }
  //   if (data?.limit) {
  //     url += `&limit=${data.limit}`;
  //   }
  //   let res = await APIService.get(url);
  //   return res;
  // };

  const updateUserDetail = async (data) => {
    let res = await APIService.put(Apis.getDetailsByNumber, data);
    return res;
  };
  const createUserDetail = async (data) => {
    let res = await APIService.post(Apis.getDetailsByNumber, data);
    return res;
  };

  const postInterveneCdrData = async (data) => {
    let res = await APIService.post(`${Apis.postInterveneCdrData}`, data);
    return res;
    // if (res?.status === 200) SweetAlert(res?.data?.data, 'success');
    // else SweetAlert('Error', 'error');
  };
  const updateInterveneCdrData = async (data) => {
    let res = await APIService.put(`${Apis.postInterveneCdrData}`, data);
    return res;
  };

  const getCustomerRecordings = async (obj) => {
    let res = await APIService.get(
      `${Apis.postInterveneCdrData}?destination=${obj?.destination}&disposition=${obj?.disposition || ''}`
    );
    return res;
  };

  const getAgentSummaryData = async (obj) => {
    let res = await APIService.get(
      `${Apis.getAgentSummaryData}?search=${obj?.search || ''}&disposition=${obj?.disposition || ''}&page=${obj?.page + 1 || 1}&start_date=${obj?.startDate ? dateFormate(obj?.startDate, 'YYYY-MM-DD') : ''}&end_date=${obj?.endDate ? dateFormate(obj?.endDate, 'YYYY-MM-DD') : ''}`
    );
    return res;
  };

  const getAgentDatewiseSummaryData = async (obj) => {
    let res = await APIService.get(
      `${Apis.getAgentDatewiseSummaryData}?agent_number=${obj?.agentNumber || ''}&disposition=${obj?.disposition || ''}&page=${obj?.page + 1 || 1}&disposition_list=${obj?.dispositionStatusList || ''}&start_date=${obj?.startDate ? dateFormate(obj?.startDate, 'YYYY-MM-DD') : ''}&end_date=${obj?.endDate ? dateFormate(obj?.endDate, 'YYYY-MM-DD') : ''}`
    );
    return res;
  };

  const getAgentUsers = async (obj) => {
    let res = await APIService.get(
      `${Apis.getAgentUsers}?agent_number=${obj?.agentNumber || ''}&disposition=${obj?.disposition || ''}&page=${obj?.page + 1 || 1}&date=${obj?.date}&search=${obj?.search || ''}`
    );
    return res;
  };

  const getRawLeadForm = async () => {
    let res = await APIService.get(`${Apis.getRawLeadForm}`);
    return res;
  };

  // const getLeadDataByLeadId = async(params)=>{
  //   let res = await APIService.get(`${Apis.getLeadDataByLeadId}?leads_form_id=${params?.leadform_Id || ''}&lead_id=${params?.lead_id || ''}`);
  //   return res;
  // }

  const getCampaignLeadSummary = async (params) => {
    try {
      const res = await APIService.get(
        `${Apis.CampaignWiseLeadSummary}?campaign_id=${params?.campaign_id}&status_id=${params?.status_id ?? ''}&leads_form_id=${params?.leads_form_id ?? ''}`
      );
      return res;
    } catch (error) {
      console.error('Failed to fetch campaign lead summary:', error);
      return [];
    }
  };

  const fetchStatusAndSubStatus = async (data) => {
    try {
      const res = await APIService.get(
        `${Apis.statusSubStatus}?leads_form_id=${data?.leadFormId}&active=${data?.active?.value || ''}&type_of_status=${data?.type_of_status || ''}`
      );
      return res;
    } catch (error) {
      console.error('Failed to fetch campaign lead summary:', error);
    }
  };

  const deleteStatus = async (statusId) => {
    try {
      const res = await APIService.remove(`${Apis.statusSubStatus}?status_id=${statusId}`);
      return res;
    } catch (error) {
      return error;
    }
  };
  const createStatusSubStatus = async (statuses) => {
    try {
      const res = await APIService.post(`${Apis.statusSubStatus}`, statuses);
      return res;
    } catch (error) {
      console.error('Failed to create status:', error);
    }
  };

  const createLeadForm = async (payload, campaignId) => {
    const url = `/v0/ui/leads/${campaignId}/create`;
    const res = await APIService.post(url, payload);
    return res;
  };

  const updateLeadForm = async (payload, leadFormId) => {
    const url = `/v0/ui/leads/${leadFormId}/edit_form`;
    const res = await APIService.put(url, payload);
    return res;
  };

  const deleteFormFieldsByItemId = async (leadFormId, itemId) => {
    const url = `/v0/ui/leads/${leadFormId}/delete_form_element/${itemId}`;
    const res = await APIService.put(url, {});
    return res;
  };

  const insertAndUpdateLeads = async (formId, leadId, payload) => {
    let res = await APIService.post(
      `v0/ui/leads/${formId}/insert_lead?lead_id=${leadId || ''}`,
      payload
    );
    return res;
  };

  const updateLeadStatusComment = async (payload) => {
    const res = await APIService.put(`${Apis.updateStatusComment}`, payload);
    return res;
  };

  const createCampaignMapping = async (payload) => {
    const res = await APIService.post('v0/ui/proposal/create-campaign-mapping/', payload);
    return res;
  };

  const updateCampaignMapping = async (payload) => {
    const res = await APIService.put(`v0/ui/proposal/create-campaign-mapping/`, payload);
    return res;
  };

  const fetchCampaignMappings = async (campaignId) => {
    const res = await APIService.get(
      `v0/ui/proposal/create-campaign-mapping/?campaign_id=${campaignId}`
    );
    return res;
  };

  const delteCampaignMapping = async (id) => {
    const res = await APIService.remove(`v0/ui/proposal/create-campaign-mapping/?_id=${id}`);
    return res;
  };

  const getB2b2CLeads = async (filterParams) => {
    let params = `?campaign_id=${filterParams?.campaign_id}&leads_form_id=${filterParams?.leads_form_id}&offset=${filterParams?.offset || 0}&limit=${filterParams?.limit || 10}&start_date=${filterParams?.start_date || ''}&end_date=${filterParams?.end_date || ''}&status=${filterParams?.status || ''}&search=${filterParams?.search || ''}`;

    if (filterParams?.lead_id) {
      params += `&lead_id=${filterParams.lead_id}`;
    }
    if (filterParams?.sort_type && filterParams?.sort_by) {
      params += `&sort_type=${filterParams?.sort_type}&sort_by=${filterParams?.sort_by}`;
    }
    if (filterParams?.parent_lead_id) {
      params += `&parent_lead_id=${filterParams?.parent_lead_id}`;
    }
    // let dynamicFilterString = generateDynamicFilterString(state?.filters?.dynamicFilters || {});
    // if (dynamicFilterString) {
    //   params += `&${dynamicFilterString}`;
    // }
    const response = await APIService.get(`${Apis.getB2b2cLeads}${params}`);
    if (response && response.data) {
    } else {
      setLeadsData([]);
      console.log('API response is empty or invalid:', response);
    }

    return response;
  };

  const insertLeadV1 = async (payload) => {
    let res = await APIService.post(`${Apis.insertLeadV1}`, payload);
    return res;
  };
  const updateLeadV1 = async (payload) => {
    let res = await APIService.put(`${Apis.insertLeadV1}`, payload);
    return res;
  };
  // const deleteLeadV1 = async (payload) => {
  //   let res = await APIService.remove(`${Apis.insertLeadV1}?lead_id=${payload?.lead_id || ''}`);
  //   return res;
  // };

  const deleteLeadV1 = async (payload) => {
    let res = await APIService.remove(`${Apis.insertLeadV1}`, payload);
    return res;
  };
  const getLeadV1 = async (leadId) => {
    let res = await APIService.get(`${Apis.insertLeadV1}?id=${leadId}`);
    return res;
  };

  const downloadLeadsByCampaignAndFormId = async (filterData, selectedColumns) => {
    const trueKeys = Object.keys(selectedColumns)?.filter((key) => selectedColumns[key]);
    if (!filterData?.campaign_id || !filterData?.leads_form_id) return;
    let url = `/${Apis.downloadB2b2cLeads}?campaign_id=${filterData?.campaign_id}&leads_form_id=${filterData?.leads_form_id}`;
    if (filterData?.start_date && filterData?.end_date) {
      url += `&start_date=${filterData?.start_date}&end_date=${filterData?.end_date}`;
    }
    if (filterData?.dynamicFilters) {
      url += `&data_filters=${JSON.stringify(filterData?.dynamicFilters)}`;
    }
    if (trueKeys?.length > 0) {
      url += `&selected_columns=${JSON.stringify(trueKeys)}`;
    }
    await APIService.downloadFile(
      url,
      `Leads${filterData?.campaign_id ?? ''}_${filterData?.leads_form_id ?? ''}.xlsx`
    );
  };

  const uploadLeadsFile = async (leadsFormId, formData) => {
    return await APIService.post(
      `/v0/ui/leads/uploade-lead/?leads_form_id=${leadsFormId}`,
      formData,
      { 'Content-Type': 'multipart/form-data' }
    );
  };

  const downloadSampleLeadUploadFile = async (leadFormId) => {
    if (!leadFormId) return;
    try {
      const url = `/v0/ui/leads/sample-file-lead-upload/?leads_form_id=${leadFormId}`;
      await APIService.downloadFile(url, `Sample_file_${leadFormId ?? ''}.xlsx`);
    } catch (error) {
      console.warn('error while downloading sample file');
    }
  };

  const downloadHighlightedErrorFile = async (formData) => {
    try {
      return await APIService.downloadFilePOST(
        `/v0/ui/leads/download-error-file/`,
        formData,
        'lead_error_highlighted.xlsx'
      );
    } catch (error) {
      console.warn('error while downloading sample file');
    }
  };

  const leadAssignment = async (payload) => {
    try {
      const res = await APIService.post(`v0/ui/leads/assign_leads/`, payload);
      return res;
    } catch (error) {
      return error;
    }
  };
  const leadUnAssignment = async (payload) => {
    try {
      const res = await APIService.post(`v0/ui/leads/unassign_leads/`, payload);
      return res;
    } catch (error) {
      return error;
    }
  };

  // Get Scheduler by Lead Form ID
  const getSchedulerByLeadFormId = async (leadFormId) => {
    try {
      const res = await APIService.get(`/v0/ui/leads/create-scheduler/?lead_form_id=${leadFormId}`);
      return res;
    } catch (error) {
      SweetAlert('Failed to fetch scheduler data', 'error');
    }
  };

  // Post/Create Scheduler Trigger
  const postLeadScheduler = async (payload) => {
    try {
      const formData = new URLSearchParams();
      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const res = await APIService.post(`/v0/ui/leads/create-scheduler/`, formData.toString(), {
        'Content-Type': 'application/x-www-form-urlencoded',
      });

      if (res?.data?.status) {
        SweetAlert('Scheduler created successfully', 'success');
      } else {
        SweetAlert('Failed to create scheduler', 'error');
      }

      return res;
    } catch (error) {
      SweetAlert('Error while creating scheduler', 'error');
    }
  };
  const getLeadScheduler = async (formId) => {
    try {
      const res = await APIService.get(`${Apis.leadSchedular}?form_id=${formId}`);
      return res;
    } catch (error) {
      return error;
    }
  };

  const createLeadScheduler = async (payload) => {
    try {
      const res = await APIService.post(Apis.leadSchedular, payload);
      return res;
    } catch (error) {
      return error;
    }
  };

  const updateLeadScheduler = async (payload) => {
    try {
      const res = await APIService.put(
        `${Apis.leadSchedular}?scheduler_id=${payload?.scheduler_id ?? ''}`,
        payload
      );
      return res;
    } catch (error) {
      return error;
    }
  };
  const deleteLeadScheduler = async (schedularId) => {
    try {
      const res = await APIService.remove(`${Apis.leadSchedular}?scheduler_id=${schedularId}`);
      return res;
    } catch (error) {
      return error;
    }
  };

  const getHelpFiles = async (leadsFormId) => {
    return await APIService.get(`/v0/ui/leads/helpfile/files/?leads_form_id=${leadsFormId}`);
  };

  const uploadHelpFile = async (leadsFormId, file, fileName) => {
    const formData = new FormData();
    formData.append('leads_form_id', String(leadsFormId || ''));
    formData.append('file_name', fileName || 'help file');
    formData.append('excel_file', file);

    const res = await APIService.post(`/v0/ui/leads/helpfile/upload/`, formData, {
      'Content-Type': 'multipart/form-data',
    });
    return res;
  };

  const getHelperFileDetails = async (fileId, search = '', columnFilters = {}) => {
    let url = `/v0/ui/leads/helpfile/file-detail/?file_id=${fileId}&search=${search}`;

    Object.entries(columnFilters).forEach(([key, val]) => {
      if (val) url += `&${key}=${encodeURIComponent(val)}`;
    });

    const res = await APIService.get(url);
    return res;
  };

  const deleteHelpFile = async (fileId) => {
    try {
      const res = await APIService.remove(`/v0/ui/leads/helpfile/file-detail/?file_id=${fileId}`);
      return res;
    } catch (error) {
      return error;
    }
  };

  const updateStatusList = async (payload) => {
    const res = await APIService.post(`/v0/ui/leads/update-sort-web-formstatus/`, payload);
    return res;
  };

  const getAiChatDetail = async (leadId) => {
    try {
      const res = await APIService.get(`/v0/ui/leads/detail-ai-chat/${leadId}/`);
      return res;
    } catch (error) {
      return null;
    }
  };

  const moveCampaign = async (payload) => {
    try {
      const res = await APIService.post(`/v0/ui/leads/move_leads/`, payload);
      return res;
    } catch (error) {
      return error;
    }
  };

  return {
    updateLeadStatusDate,
    updateLeadStatusDate1,
    fetchLeadStatus,
    addReferences,
    getCommentById,
    postCommentById,
    getLeadImagesById,
    uploadLeadImageById,
    getLeadAudioById,
    uploadLeadAudioById,
    getFormsByCampaignId,
    getLeadsByFormId,
    getDetailsByNumber,
    getLeadCounts,
    updateQcStatus,
    // getUserDetailsByParams,
    updateUserDetail,
    createUserDetail,
    despositionStatusArr,
    postInterveneCdrData,
    updateInterveneCdrData,
    getCustomerRecordings,
    getAgentSummaryData,
    getAgentDatewiseSummaryData,
    getAgentUsers,
    getRawLeadForm,
    // getLeadDataByLeadId
    getCampaignLeadSummary,
    fetchStatusAndSubStatus,
    createLeadForm,
    updateLeadForm,
    deleteFormFieldsByItemId,
    createStatusSubStatus,
    insertAndUpdateLeads,
    updateLeadStatusComment,
    createCampaignMapping,
    updateCampaignMapping,
    delteCampaignMapping,
    fetchCampaignMappings,
    getB2b2CLeads,
    insertLeadV1,
    updateLeadV1,
    deleteLeadV1,
    getLeadV1,
    downloadLeadsByCampaignAndFormId,
    downloadHighlightedErrorFile,
    fetchLeadStatus1,
    uploadLeadsFile,
    downloadSampleLeadUploadFile,
    leadAssignment,
    leadUnAssignment,
    getSchedulerByLeadFormId,
    postLeadScheduler,
    getLeadScheduler,
    createLeadScheduler,
    updateLeadScheduler,
    deleteLeadScheduler,
    deleteStatus,
    getHelpFiles,
    uploadHelpFile,
    getHelperFileDetails,
    deleteHelpFile,
    updateStatusList,
    getAiChatDetail,
    moveCampaign,
  };
};

export { LeadFormActions };
